// modalConstants.js
'use strict';

export const ModalStatus = {
  DISPLAY: 'display',
  HIDDEN: 'hidden',
  OPENING: 'opening',
  CLOSING: 'closing',
};

export const ANIMATION_DURATION_MSEC = 600;
